import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { router } from "@/router";
import { store } from "@/store";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function logout() {
  store.commit("logout");
  router.push("/login");
}
onMounted(() => logout());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})